// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1ft1n","errorLogs":"styles_errorLogs__7_IRT"};